<template>
  <v-container v-if="notifications">
    <v-row>
      <v-col cols="12">
        <v-alert outlined type="info" border="left">
          Téléchargez le
          <a href @click.prevent="downloadReport">rapport</a> complet des
          notifications envoyées.
        </v-alert>
      </v-col>
    </v-row>
    <v-row class="text-left mb-10">
      <v-col cols="12" sm="4">
        <v-card>
          <v-list two-line>
            <v-list-item-group v-if="notifications && !notifications.length"
              ><v-list-item>Pas de résultats...</v-list-item></v-list-item-group
            >
            <v-list-item-group v-else>
              <template v-for="(notification, index) in notifications">
                <v-list-item
                  :key="notification._id"
                  @click="selectnotification(notification)"
                >
                  <template>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="
                          `${notification.request.firstname} ${notification.request.lastname}`
                        "
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        class="text--primary"
                        v-text="notification.subject"
                      ></v-list-item-subtitle>

                      <v-list-item-subtitle
                        v-text="
                          parser
                            .parseFromString(notification.html, 'text/html')
                            .getElementsByTagName('body')[0]
                            .textContent.substr(0, 50)
                        "
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-list-item-action-text
                        v-text="
                          `${format(parseISO(notification.date), 'dd.MM.yyyy')}`
                        "
                      ></v-list-item-action-text>
                      <v-icon> </v-icon>
                    </v-list-item-action>
                  </template>
                </v-list-item>

                <v-divider
                  v-if="index < notifications.length - 1"
                  :key="index"
                ></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card>
        <div class="text-center mt-5">
          <v-pagination
            v-model="options.page"
            :length="totalPages"
            v-if="notifications.length && totalPages > 1"
          ></v-pagination>
        </div>
      </v-col>
      <v-col v-if="selectednotification">
        <v-card class="pa-10 mb-10">
          <v-card-subtitle>
            <v-container class="pa-0">
              <v-row>
                <v-col>
                  <div class="font-weight-bold">no-reply@heig-vd.ch</div>
                  <div>{{ selectednotification.subject }}</div>
                  <div>À : {{ selectednotification.request.email }}</div>
                </v-col>
                <v-col class="text-right"
                  ><div>
                    {{
                      format(
                        parseISO(selectednotification.date),
                        "dd MMMM yyyy à HH:mm",
                        { locale: fr }
                      )
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text
            v-html="selectednotification.html"
          ></v-card-text> </v-card
      ></v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import { format, parseISO } from "date-fns";
import fr from "date-fns/locale/fr";
import { debounce } from "lodash";
import fileDownload from "js-file-download";

export default {
  name: "AdminPart",
  async mounted() {
    const { items, total, pages } = await this.getDataFromApi();
    this.notifications = items;
    this.total = total;
    this.totalPages = pages;
    const parser = new DOMParser();
    this.parser = parser;
  },
  data: () => ({
    parser: undefined,
    notifications: undefined,
    selectednotification: undefined,
    options: { page: 1 },
    search: "",
    total: 0,
    totalPages: 0,
    loading: false,
    parseISO,
    format,
    fr,
  }),
  methods: {
    async getDataFromApi() {
      this.loading = true;
      const { page } = this.options;
      const { data } = await axios({
        method: "get",
        url: `${
          process.env.VUE_APP_API_URI
        }/notifications?page=${page}&search=${
          this.search
        }&itemsPerPage=10&request=${this.$route.query.request || ""}`,
      });
      this.loading = false;
      let { docs: items } = data;
      const total = data.totalDocs;
      const pages = data.totalPages;
      return {
        items,
        total,
        pages,
      };
    },
    selectnotification(notification) {
      this.selectednotification = notification;
    },

    async downloadReport() {
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/notifications-export`,
        responseType: "arraybuffer",
      });
      fileDownload(data, "notifications.xlsx");
    },
  },
  watch: {
    options: {
      async handler() {
        const data = await this.getDataFromApi();
        this.notifications = data.items;
        this.total = data.total;
        this.totalPages = data.pages;
      },
      deep: true,
    },
    search: debounce(async function () {
      this.options.page = null;
      this.options.page = 1;
    }, 500),
    "$route.params"() {
      this.options = null;
      this.options = { page: 1 };
    },
  },
};
</script>